import { alphabetically } from './array';

export const sortTemplates = templates => {
  const unarchived = templates
    .filter(t => !t.archived)
    .sort(alphabetically('name'));
  const archived = templates
    .filter(t => t.archived)
    .sort(alphabetically('name'));
  return unarchived.concat(archived);
};
